import { IntegrationsPortErrors } from 'modules/Integrations/domain'
import type { SphereIntegrationConfig } from './sphere.integration.config'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'

const enableSphereIntegration = async (): Promise<{ success: boolean }> => {
  const result = await dashboardv99990101Client.putEnabledTaxIntegration({
    taxIntegrationProvider: 'SPHERE'
  })
  return { success: !result.error }
}

export const sphereConfigurationMutator = async (
  data: SphereIntegrationConfig
): Promise<{
  success: boolean
  error: IntegrationsPortErrors | null
}> => {
  if (data.apiKey) {
    const credentialsResult =
      await dashboardv99990101Client.postStoreSphereCredentials({
        apiKey: data.apiKey
      })

    if (credentialsResult.error) {
      return { success: false, error: IntegrationsPortErrors.Other }
    }

    const enableResult = await enableSphereIntegration()
    if (!enableResult.success) {
      return { success: false, error: IntegrationsPortErrors.Other }
    }
  }

  return { success: true, error: null }
}
